var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"textBoxContainer",style:([_vm.textBoxStyle]),on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.action(_vm.app)
}}},_vm._l((_vm.itemList),function(item,index){return _c('v-uni-view',{key:index,style:([item.style])},[_vm._v(_vm._s(item.text || ''))])}),1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }